import { render, staticRenderFns } from "./CompletedView.vue?vue&type=template&id=0816e59c&"
import script from "./CompletedView.vue?vue&type=script&lang=js&"
export * from "./CompletedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports